import { Button, styled } from "@mui/material";

export const BaseStyledButton = styled(Button)(() => ({
  width: "100%",
  minWidth: "160px",
  minHeight: "100px",
}));
